import { createAction, props } from '@ngrx/store';
import { LoginResponse } from '@shared/models/login-response';

export const login = createAction('[Login] Do Login', props<{ email: string; password: string }>());

export const loginSuccess = createAction('[Login] Do Login Success', props<{ data: LoginResponse }>());

export const loginFailed = createAction('[Login] Do Login Failed', props<{ error: any }>());
